import React from "react";
import PropTypes from "prop-types";
import {
  NestedFieldSet,
  FormGroupSelect,
  FormGroupTextArea,
} from "components/formElements";
import { getOptions, getFilteredSkills } from "util/library";
import Select from 'react-select';
import { getReactSelectOptions, CustomPlaceholder, customStyles } from "util/library";

const SkillDropdowns = ({
  handleChange,
  skills,
  firstSkill,
  secondSkill,
  thirdSkill,
  additionalSkills,
  required,
}) => (
    <NestedFieldSet legendText="Skills" style={{ marginLeft: "8px" }}>
    {/*<FormGroupSelect*/}
    {/*  id="firstSkill"*/}
    {/*  name="firstSkill"*/}
    {/*  label="First Skill"*/}
    {/*  options={getOptions(*/}
    {/*    getFilteredSkills(skills, secondSkill, thirdSkill),*/}
    {/*    required ? "Select First Skill*" : "Select First Skill"*/}
    {/*  )}*/}
    {/*  value={firstSkill}*/}
    {/*  onChange={handleChange}*/}
    {/*  required={required}*/}
    {/*/>*/}
    {/*<FormGroupSelect*/}
    {/*  id="secondSkill"*/}
    {/*  name="secondSkill"*/}
    {/*  label="Second Skill"*/}
    {/*  value={secondSkill}*/}
    {/*  onChange={handleChange}*/}
    {/*  options={getOptions(*/}
    {/*    getFilteredSkills(skills, firstSkill, thirdSkill),*/}
    {/*    "Select Second Skill"*/}
    {/*  )}*/}
    {/*/>*/}
    {/*<FormGroupSelect*/}
    {/*  id="thirdSkill"*/}
    {/*  name="thirdSkill"*/}
    {/*  label="Third Skill"*/}
    {/*  value={thirdSkill}*/}
    {/*  onChange={handleChange}*/}
    {/*  options={getOptions(*/}
    {/*    getFilteredSkills(skills, firstSkill, secondSkill),*/}
    {/*    "Select Third Skill"*/}
    {/*  )}*/}
        {/*/>*/}
            <Select
                id="firstSkill"
                name="firstSkill"
                options={getReactSelectOptions(getFilteredSkills(skills, secondSkill, thirdSkill))}
                value={getReactSelectOptions(getFilteredSkills(skills, secondSkill, thirdSkill)).find(
                    (opt) => opt.value === firstSkill
                )}
                onChange={(selected) =>
                    handleChange({
                        target: { name: "firstSkill", value: selected ? selected.value : "" },
                    })
                }
                placeholder={
                    required ? (
                        <CustomPlaceholder text="Select First Skill" />
                    ) : (
                        "Select First Skill"
                    )
                }
                styles={customStyles}
                isClearable={true}
            />

            <Select
                id="secondSkill"
                name="secondSkill"
                options={getReactSelectOptions(getFilteredSkills(skills, firstSkill, thirdSkill))}
                value={getReactSelectOptions(getFilteredSkills(skills, firstSkill, thirdSkill)).find(
                    (opt) => opt.value === secondSkill
                )}
                onChange={(selected) =>
                    handleChange({
                        target: { name: "secondSkill", value: selected ? selected.value : "" },
                    })
                }
                placeholder="Select Second Skill"
            styles={customStyles}
                isClearable={true}
            />

            <Select
                id="thirdSkill"
                name="thirdSkill"
                options={getReactSelectOptions(getFilteredSkills(skills, firstSkill, secondSkill))}
                value={getReactSelectOptions(getFilteredSkills(skills, firstSkill, secondSkill)).find(
                    (opt) => opt.value === thirdSkill
                )}
                onChange={(selected) =>
                    handleChange({
                        target: { name: "thirdSkill", value: selected ? selected.value : "" },
                    })
                }
                placeholder="Select Third Skill"
            styles={customStyles}
                isClearable={true}
            />

    {/*<FormGroupTextArea*/}
    {/*  id="additionalSkills"*/}
    {/*  name="additionalSkills"*/}
    {/*  label="Additional Skills/ Specialization (comma separated)"*/}
    {/*  //placeholder="Comma separated list of skills"*/}
    {/*  value={additionalSkills}*/}
    {/*  onChange={handleChange}*/}
        {/*/>*/}
            <textarea
                id="additionalSkills"
                name="additionalSkills"
                value={additionalSkills}
                onChange={handleChange}
                placeholder="Additional Skills/ Specialization (comma separated)"
                style={{
                    width: "48%",
                    minHeight: "80px",
                    padding: "8px",
                    fontSize: "14px",
                    border: "1px solid grey",
                    borderRadius: "2px",
                    resize: "vertical",
                    marginLeft: "8px",
                    marginTop:"4px"
                }}
            />
  </NestedFieldSet>
);

SkillDropdowns.propTypes = {
  handleChange: PropTypes.func.isRequired,
  skills: PropTypes.array.isRequired,
  firstSkill: PropTypes.string.isRequired,
  secondSkill: PropTypes.string.isRequired,
  thirdSkill: PropTypes.string.isRequired,
  additionalSkills: PropTypes.string.isRequired,
};

export { SkillDropdowns };
